
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Stkpi19Component } from './stkpi19.component';
import { Stkpi19DetailComponent } from './stkpi19-detail.component';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-stkpi19-bill',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, Stkpi19Component, Stkpi19DetailComponent],
  templateUrl: './stkpi19BillPkg.component.html',
  styleUrls: [],
})
export class Stkpi19BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' stkpi19'; //###
  override masterPage!: Stkpi19Component;
  override detailPage!: Stkpi19DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
